<script>
import forminput from "../../FormComponet/forminput.vue";
import formcombobox from "../../FormComponet/formcombobox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfTablolarDetayParametreTanim from "@/models/strperftablolardetayparametretanim"; 
export default {
  mixins: [Api, Sabit, StrPerfTablolarDetayParametreTanim],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      Combobox: false,

    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,

  },
  watch: {
    Id() {
      this.FormData = this.Id;
      if(this.FormData != null){
        this.KodNumber();
      }

    },
  },
  methods: {
    KodNumber(){                 
      this.ActionsSingleGet({Service:"OKeyValues", Id: this.FormData.Tip, }).then((res) => {
          if(res.Data != null){
            if(res.Data.Kod == 5){
              this.Combobox = true
            }else{
              this.Combobox = false
              this.FormData.Comboboxveribaslikid = null;
            }
          }else{
            this.Combobox = false;
            this.FormData.Comboboxveribaslikid = null;
          }
        
      });  
    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        

        if (this.AddEdit == "Add") { 
           this.$delete(this.FormData, "Id");
              this.Post("StrPerfTablolarDetayParametreTanim", this.FormData).then((res) => { 
                if (res) {       
                    this.$bvModal.hide("StrPerfTablolarDetayParametreTanim");
                    this.$emit("TableUpdate");
                }
              });
        } else {
         
         this.Update("StrPerfTablolarDetayParametreTanim", this.FormData).then((res) => {
              if (res) {
                
                this.$bvModal.hide("StrPerfTablolarDetayParametreTanim");
                this.$emit("TableUpdate");
              }
         });

        }
      }
    },
  },
};
</script>
<template>


  <Loader>

  
    <b-modal
      id="StrPerfTablolarDetayParametreTanim"
      size="lg"
       :title="this.AddEdit == 'Edit' ? $t('StrPerfTablolarDetayParametreTanim.AddEdit.FormTitleEdit')
          : $t('StrPerfTablolarDetayParametreTanim.AddEdit.FormTitleAdd')"
      title-class="font-18"
      hide-footer
    >

  <Form  @submit.prevent="onSubmit" > 
                       <div class="row">
                         <div class="col-md-12">
                            

                        <div class="row">
                            <div class="col-md-12">

                               <forminput
                                  :title_position="'mb-3'"
                                  :labels_lg="3"
                                  :FormDataType="FormDataType.Parametreadi"
                                  :Value="FormData.Parametreadi"
                                  :v="$v.FormData.Parametreadi"
                                  @input="FormData.Parametreadi = $event"
                                />  

                              <formcombobox
                                  :title_position="'mb-3'"
                                  :labels_lg="3"
                                  :FormDataType="FormDataType.Tip"
                                  :Value="FormData.Tip"
                                  :v="$v.FormData.Tip"
                                  @input="(FormData.Tip = $event), KodNumber()"
                                />

                                <formcombobox v-if="Combobox == true"
                                  :title_position="'mb-3'"
                                  :labels_lg="3"
                                  :FormDataType="FormDataType.Comboboxveribaslikid"
                                  :Value="FormData.Comboboxveribaslikid"
                                  :v="$v.FormData.Comboboxveribaslikid"
                                  @input="FormData.Comboboxveribaslikid = $event"
                                />
                          

                            </div>
                        </div>


                         
         

                        
                         </div>
                            </div>

                    
                            <hr>
                       
                            <button class="btn btn-primary"  type="submit" >{{ $t("StrPerfTablolarDetayParametreTanim.AddEdit.Button") }}</button> 

                          </Form>                       
                       


    </b-modal>
  </Loader>
</template>
